import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { analyticsTracker } from 'uitk-react-utils';

var UitkDateRangeGridCell = function (props) {
    var result = props.result, onClickCB = props.onClickCB, className = props.className, attrs = __rest(props, ["result", "onClickCB", "className"]);
    var priceText = result.priceText, onClickCallback = result.onClickCallback, analytics = result.analytics, isLink = result.isLink;
    var onClickCapture = function () {
        analytics && analyticsTracker(analytics);
        onClickCallback && onClickCallback();
    };
    var buttonIsDisabled = result.theme === 'unavailable';
    return (React.createElement("button", __assign({ onClickCapture: onClickCapture, onClick: onClickCB, role: isLink ? 'link' : undefined, type: "button" }, attrs, (buttonIsDisabled && {
        disabled: true,
        tabIndex: -1
    }), { className: className }), priceText));
};

export { UitkDateRangeGridCell };
